import axios from 'axios';
import { Helpers } from '../helpers/Helpers';

export class DashboardService {
    static async getAntrepoDashboard1() {
        try {
            var inputObj = {
            };

            console.log('SERVICE CALL - getAntrepoDashboard1', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/Dashboard/getAntrepoDashboard1', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async getMarketingDashboard() {
        try {
            var inputObj = {
            };

            console.log('SERVICE CALL - getMarketingDashboard', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/Dashboard/getMarketingDashboard', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async getModuleDashboard(module: string, startDate: string | undefined, endDate: string | undefined, forceRefresh: boolean) {
        try {
            var inputObj = {
                module: module,
                startDate: startDate,
                endDate: endDate,
                forceRefresh: forceRefresh
            };

            console.log('SERVICE CALL - getModuleDashboard', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/Dashboard/getModuleDashboard', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }
}